import { PostBlockWeb } from '@nucleus/types/web';
import invariant from 'invariant';
import React, { createContext, useContext } from 'react';

const Context = createContext<ReturnType<typeof useController>>(null!);
Context.displayName = 'PostBlockController';

type Props = {
  children: React.ReactNode;
} & Options;

export const PostBlockController = ({ children, ...props }: Props): JSX.Element => {
  return <Context.Provider value={useController(props)}>{children}</Context.Provider>;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const usePostBlockController = () => {
  invariant(
    useContext(Context) !== null,
    'usePostBlockController() may be used only in the context of a <PostBlockController> object'
  );
  return useContext(Context);
};

interface Options {
  isImageVisible?: boolean;
  layout?: PostBlockWeb['layout'];
}

const useController = (options: Options) => {
  const [currentLayout, setCurrentLayout] = React.useState(options.layout ?? 'grid');

  return {
    currentLayout: currentLayout,
    isImageVisible: options.isImageVisible ?? true,
    onLayoutChange: setCurrentLayout,
  };
};
